import classNames from 'classnames';
import { Loader } from 'components/atoms/Loader';
import AIIcon from 'components/atoms/SVG/AIIcon';
import type { FC } from 'react';
import AIChatSpinner from './AIChatMessageSkeleton';

type AIChatMessageAvatarProps = {
  role: string;
  isLoading: boolean;
  isStreaming: boolean;
  isSmall: boolean;
};

const AIChatMessageAvatar: FC<AIChatMessageAvatarProps> = ({
  role,
  isLoading,
  isStreaming,
  isSmall,
}) => {
  if (role === 'user') return null;
  if (isStreaming) return <AIChatSpinner size={isSmall ? 'small' : 'medium'} />;
  return isLoading ? (
    <Loader />
  ) : (
    <div
      className={classNames(
        'rounded-full bg-taxes-200 flex items-stretch justify-center',
        isSmall ? 'w-5 h-5 p-[1px]' : 'w-8 h-8 p-[1px]',
      )}
    >
      <div
        className={classNames(
          'flex flex-1 items-center justify-center rounded-full bg-white',
        )}
      >
        <AIIcon
          stroke="#8059C8"
          className={classNames(isSmall ? 'w-4 h-4' : 'w-7 h-7')}
        />
      </div>
    </div>
  );
};

export default AIChatMessageAvatar;
